import * as slug from "slug";

export const getTraclinkSlug = (value: string) => {
  return slug(value).replace(/-/g, "");
};
